window.addEventListener("load", (event) => {
  function renderStaticNameCollection (params) {
  const listCollection = document.querySelectorAll(".list-collections__item-list img");
  listCollection.forEach((collection)=>{
    const parentNodeCollection = collection.parentNode;
    console.log(parentNodeCollection)
    
    const altCollection = collection.getAttribute("alt");
    console.log(altCollection);

    const titleCollection = document.createElement("h3");
    titleCollection.classList.add("titleCollectionMain");
    titleCollection.innerText = altCollection;

    parentNodeCollection.append(titleCollection);
  })
  }
  renderStaticNameCollection();
});